var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 18,
    height: 18,
    transform: "translate(255 11)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_54",
    "data-name": "Mask Group 54",
    transform: "translate(-255 -11)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(254.433 10.463)",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M9.259.537.6,4.707v2.17H18.537V4.7Zm8.081,5.144H1.794V5.458l7.483-3.6L17.341,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M1.794,15.248H17.341v1.2H1.794Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M.6,17.341H18.537v1.2H.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M2.093,8.072h1.2v5.98h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M15.846,8.072h1.2v5.98h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M12.258,8.072h1.2v5.98h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M5.681,8.072h1.2v5.98h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M8.969,8.072h1.2v5.98h-1.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanking);
export default __webpack_public_path__ + "static/media/banking.de7e383f65ccf3992fb19efa31b0a034.svg";
export { ForwardRef as ReactComponent };